import script from "./UserProfileCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfileCard.vue?vue&type=script&setup=true&lang=ts"

import "@/components/user/UserProfileCard.css?vue&type=style&index=0&id=d05ab052&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d05ab052"]])

export default __exports__